<template>
  <div class="cabinet-console-hello-user">
    <img class="icon" src="/assets/images/cabinet_user.svg" alt />
    <div class="indicator">
      <div>{{ $t('consoleHeader.hello') }},</div>
      <div>{{ fullNameFromUser }}</div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'

import { getCurrentInstance, ref } from "@vue/runtime-core";
import { Logger } from "aws-amplify";

const logger = new Logger("main")

export default {
  name: "ConsoleAvailableBalance",
  setup() {
    let fullNameFromUser = ref('-')

    const store = useStore()

    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter

    emitter.on("userUpdated", () => {
      // console.log('--- ON USER UPDATED ---')
      // console.log(store.state.user.id)
      updateHeader()
    })

    const updateHeader = () => {
      if (store.state.user !== null) {
        fullNameFromUser.value = store.state.user.firstName
      }
      /* else {
        logger.error('user is null')
      } */
    }

    updateHeader()
    return {
      fullNameFromUser
    }
  }
}
</script>
